/*
* <license header>
*/

import React from 'react'
import { Flex, Heading, Text, View } from '@adobe/react-spectrum'
import { useNavigate } from 'react-router-dom'
import App from '@spectrum-icons/workflow/App'
import Starburst from '@spectrum-icons/workflow/Starburst'
import FileTemplate from '@spectrum-icons/workflow/FileTemplate'
import Code from '@spectrum-icons/workflow/Code'
import { APP_TYPES, APPS } from '../../data/constants'

const CATEGORIES = [
  {
    icon: App,
    iconColor: '#e53935',
    badge: APP_TYPES.length,
    title: 'App Types',
    description: 'Adobe Recommended app builder types: Asset Compute, Workfront, AEM, MCP server, and more.',
    path: '/app-types'
  },
  {
    icon: Starburst,
    iconColor: '#2196f3',
    badge: APPS.length,
    title: 'Applications',
    description: 'Your created and managed apps with deployment status and configuration.',
    path: '/apps'
  },
  {
    icon: Code,
    iconColor: '#673ab7',
    badge: 2,
    title: 'Supported LLMs',
    description: 'OpenAI and Anthropic models for the AI Assistant, vibe coding, and agentic workflows.',
    path: '/ask-assistant'
  },
  {
    icon: Starburst,
    iconColor: '#4caf50',
    badge: 4,
    title: 'RAG Sources',
    description: 'Documentation from Adobe Console, Extensions, AppBuilder Factory, and Spectrum for contextual AI guidance.',
    path: '/ask-assistant'
  },
  {
    icon: FileTemplate,
    iconColor: '#ff9800',
    badge: APP_TYPES.length,
    title: 'Templates',
    description: 'Pre-built templates and real-world examples. Bootstrap from proven structures and customize to your needs.',
    path: '/app-templates'
  }
]

const CARD_STYLE = {
  border: '1px solid var(--card-border)',
  borderRadius: '8px',
  padding: '1.5rem',
  backgroundColor: 'var(--white)',
  cursor: 'pointer',
  transition: 'box-shadow 0.2s ease'
}

export const ExploreByCategorySection = () => {
  const navigate = useNavigate()

  return (
    <View marginBottom="size-600">
      <Heading level={2} UNSAFE_style={{ margin: 0, marginBottom: '1.25rem', fontSize: '1.25rem', fontWeight: 700 }}>
        Explore by Category
      </Heading>
      <div className="ExploreByCategory-grid">
        {CATEGORIES.map(({ icon: Icon, iconColor, badge, title, description, path }) => (
          <View
            key={title}
            UNSAFE_style={CARD_STYLE}
            onClick={() => navigate(path)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && navigate(path)}
          >
            <Flex direction="column" gap="size-200">
              <Flex alignItems="flex-start" justifyContent="space-between" gap="size-100">
                <View
                  UNSAFE_style={{
                    width: '2.5rem',
                    height: '2.5rem',
                    borderRadius: '8px',
                    backgroundColor: `${iconColor}20`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Icon size="M" UNSAFE_style={{ color: iconColor }} />
                </View>
                <View
                  UNSAFE_style={{
                    padding: '0.25rem 0.5rem',
                    borderRadius: '4px',
                    backgroundColor: 'var(--gray-200)',
                    fontSize: '0.75rem',
                    fontWeight: 600
                  }}
                >
                  {badge}
                </View>
              </Flex>
              <Heading level={3} UNSAFE_style={{ margin: 0, fontSize: '1rem', fontWeight: 600 }}>
                {title}
              </Heading>
              <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.875rem', lineHeight: 1.5 }}>
                {description}
              </Text>
            </Flex>
          </View>
        ))}
      </div>
    </View>
  )
}
